import React from "react";
import FeatureHeader from "../components/FeatureHeader";
import Icon from "../components/Icon";
import "./BusyBees.css";

const VOLUNTEER_EMAIL = "volunteer@bugandfrog.org";
const JOIN_MAILTO = `mailto:${VOLUNTEER_EMAIL}?subject=${encodeURIComponent("I'd like to join Busy Bees")}`;
const EMAIL_MAILTO = `mailto:${VOLUNTEER_EMAIL}?subject=${encodeURIComponent("Busy Bees question")}`;

const supplies = [
  {
    icon: "handCoins",
    title: "All the funding",
    description: "Every cost is covered by the foundation, so you never spend a dime to volunteer with us."
  },
  {
    icon: "scissors",
    title: "All the crafting supplies",
    description:
      "Yarn, fabric, thread, patterns, and tools: everything you need to stitch, crochet, knit, or craft."
  },
  {
    icon: "cookie",
    title: "All the snacks",
    description: "Coffee, treats, and good company. Just bring your hands and your heart."
  }
];

// Chip colors cycle green → white → beige, as in the design.
const makes = [
  "Baby blankets",
  "Hats and booties",
  "Scent hearts",
  "Burp cloths",
  "NICU octopuses",
  "Comfort loveys",
  "Keepsakes"
];
const CHIP_TONES = ["green", "white", "beige"];

const steps = [
  { title: "Say hello", description: "Reach out and let us know you'd like to join the Busy Bees." },
  { title: "Come craft", description: "Join a crafting session, in a group or from the comfort of home." },
  { title: "Bring joy", description: "Your creations go straight into care packages for NICU families." }
];

export default function BusyBees() {
  return (
    <div className="busy-bees">
      <FeatureHeader badge="Crafters wanted" icon="sparkles" title="Busy Bees">
        Our volunteer crafting community, making handmade comfort for NICU and PICU families. If you can craft, we'd love your hands. No experience or supplies needed. You bring the creativity; we take care of everything else.
      </FeatureHeader>

      <section>
        <div className="container bb-narrow">
          <div className="bb-supplies">
            <div className="bb-section-heading">
              <h2>We supply everything</h2>
              <p>Show up as you are. The foundation covers the rest.</p>
            </div>
            <ul className="bb-supply-list">
              {supplies.map((item) => (
                <li className="bb-supply-row" key={item.title}>
                  <span className="bb-icon-circle">
                    <Icon name={item.icon} size={32} />
                  </span>
                  <div>
                    <h3>{item.title}</h3>
                    <p>{item.description}</p>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      <section>
        <div className="container bb-narrow">
          <div className="bb-section-heading">
            <h2>What you'll make</h2>
            <p>Handmade with love, delivered where it matters most.</p>
          </div>
          <ul className="bb-chips">
            {makes.map((item, index) => (
              <li key={item} className={`bb-chip bb-chip-${CHIP_TONES[index % CHIP_TONES.length]}`}>
                {item}
              </li>
            ))}
          </ul>
        </div>
      </section>

      <section>
        <div className="container bb-narrow">
          <div className="bb-section-heading">
            <h2>How it works</h2>
            <p>Getting started takes just three simple steps.</p>
          </div>
          <ol className="bb-steps">
            {steps.map((step, index) => (
              <li key={step.title}>
                <span className="bb-step-number" aria-hidden="true">
                  {index + 1}
                </span>
                <div>
                  <h3>{step.title}</h3>
                  <p>{step.description}</p>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </section>

      <section className="bb-cta-section">
        <div className="container bb-narrow">
          <div className="bb-cta">
            <h2>Ready to join the hive?</h2>
            <p>
              Whether you knit, sew, crochet, or just want to help, there's a seat at the table (and
              a snack) waiting for you.
            </p>
            <div className="bb-cta-actions">
              <a href={JOIN_MAILTO} className="btn">
                Become a Busy Bee <Icon name="arrowRight" size={16} />
              </a>
              <a href={EMAIL_MAILTO} className="bb-btn-ghost">
                Email us
              </a>
            </div>
            <p className="bb-cta-note">
              <span>{VOLUNTEER_EMAIL}</span>
              <span className="bb-cta-sep" aria-hidden="true">
                {" "}·{" "}
              </span>
              <a href="https://www.instagram.com/thebugfrogfoundation/" target="_blank" rel="noopener noreferrer">
                @thebugfrogfoundation
              </a>
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
